module.exports = __webpack_public_path__ + "static/img/Image 20.186fb179.png";